import { render } from "./Video.vue?vue&type=template&id=19d10586&scoped=true"
import script from "./Video.vue?vue&type=script&lang=js"
export * from "./Video.vue?vue&type=script&lang=js"

import "./Video.vue?vue&type=style&index=0&id=19d10586&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-19d10586"

export default script